export default {
  dashboard: {
    hi: 'general.hi',
    yourCurrentPlan: 'dashboard.yourCurrentPlan',
    edit: 'general.edit',
    expired: 'dashboard.expired',
    startedfrom: 'dashboard.startedfrom',
    nextBillableDate: 'dashboard.nextBillableDate',
    youHave: 'dashboard.youHave',
    licences: 'dashboard.licences',
    manageLicences: 'dashboard.manageLicences',
    billingHistory: 'dashboard.billingHistory',
    receipt: 'dashboard.receipt',
    youHaveNoBillingHistory: 'dashboard.youHaveNoBillingHistory',
    accountInformation: 'dashboard.accountInformation',
    name: 'dashboard.name',
    email: 'dashboard.email',
    phone: 'dashboard.phone',
    clinicName: 'dashboard.clinicName',
    yourPosition: 'dashboard.yourPosition',
    passwordDetails: 'dashboard.passwordDetails',
    creditCardDetails: 'dashboard.creditCardDetails',
    clickCounter: 'dashboard.clickCounter',
    change: 'dashboard.change',
    contactUs: 'dashboard.contactUs',
    pleaseClick: 'dashboard.pleaseClick',
    here: 'dashboard.here',
    help: 'dashboard.help',
  },
};
